import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50">奇妙漫画</span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              免费韩漫在线阅读平台，为您提供好看且高质量的韩国漫画资源。每日更新，畅享阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-400 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-secondary-400 hover:text-background-50 transition-colors">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-background-50 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-background-50 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于奇妙漫画</h4>
            <p className="text-sm text-secondary-400 leading-relaxed">
              奇妙漫画网致力于打造最好的韩漫阅读社区。我们相信每一部漫画都有值得被发现的精彩。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2026 奇妙漫画网 qimiaomanhua.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}